var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 7.38723V8.00056C14.1645 9.43818 13.699 10.837 12.8383 11.9884C11.9775 13.1399 10.7676 13.9822 9.38894 14.3898C8.01032 14.7974 6.53687 14.7485 5.18835 14.2503C3.83982 13.7521 2.68847 12.8313 1.906 11.6253C1.12354 10.4192 0.751892 8.9926 0.846482 7.5581C0.941073 6.1236 1.49684 4.75811 2.43088 3.66528C3.36493 2.57244 4.62722 1.81082 6.02949 1.49399C7.43176 1.17717 8.89888 1.32212 10.212 1.90723M14.1654 2.66723L7.4987 9.34056L5.4987 7.34056",
    stroke: "#FF671E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepChecked);
export default __webpack_public_path__ + "static/media/step-checked.0bba34a6fec1fc59fe6f21aa35c0c51c.svg";
export { ForwardRef as ReactComponent };